import React from "react";
import { ordinalSuffix } from "utils";

const Rank = ({ className, children }) => {
  const formatted = ordinalSuffix(children);
  return <span className={className}>{formatted}</span>;
};

export default Rank;
